import AddIcon from '@mui/icons-material/Add';
import BarChartIcon from '@mui/icons-material/BarChart';

export const QUICK_ACTIONS = [
    {
        id: 'new-project',
        label: 'New Project',
        icon: AddIcon,
        color: 'primary',
    },
    // {
    //     id: 'new-task',
    //     label: 'New Task',
    //     icon: PlayArrowIcon,
    //     color: 'primary',
    // },
    {
        id: 'create-report',
        label: 'Create Report',
        icon: BarChartIcon,
        color: 'primary',
    },
];
